import STORIES_API from 'api/stories/v1'
import { call, takeLatest, put, select } from 'redux-saga/effects'
import { FETCH_LIST, SEND_EVENT, SET_DATA } from 'modules/Stories/store/types'
import { actionSetData } from 'modules/Stories/store/actions'

function* fetchList({ payload = {} }) {
  const { lang } = payload
  try {
    yield put(actionSetData({ loading: true }))

    const { response, error } = yield call(STORIES_API.fetchList, {
      params: { lang },
    })

    if (error) {
      throw error
    }

    const { data } = response
    yield put(actionSetData({ data, loaded: true }))
  } catch (error) {
    console.logXHR(error)
    yield put({
      type: SET_DATA,
      payload: { failed: true },
    })
  } finally {
    yield put(actionSetData({ loading: false }))
  }
}

function* sendEvent({ payload = {} }) {
  const { ...data } = payload
  const stories = yield select(({ stories }) => stories) ?? { data: [] }
  try {
    yield put(
      actionSetData({
        data: (stories.data ?? []).map(({ stories, ...rest }) => ({
          ...rest,
          stories: stories.map(({ id, ...story }) =>
            id === data.story_id
              ? {
                  id,
                  ...story,
                  [data.event === 'unliked' ? 'liked' : data.event]: data.event !== 'unliked',
                }
              : { id, ...story },
          ),
        })),
      }),
    )

    const { error } = yield call(STORIES_API.sendEvent, {
      data,
    })

    if (error) {
      throw error
    }
  } catch (error) {
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_LIST, fetchList)
  yield takeLatest(SEND_EVENT, sendEvent)
}
